module.exports = __webpack_public_path__ + "static/media/banner_vantagens.9723f18e.png";